<ng-container *rxFor="let toast of toasts$; let i = index">
  <app-toast [toast]="toast" [i]="i" (remove)="remove($event)"></app-toast>
</ng-container>
